export const PreviewStyle = {

  variants: {
    wrapper: {
      '.previewWrapper': {
        display: 'flex',
        justifyContent: 'space-between',
      },
      '.actionWrapper': {
        width: '28%',
        '.panel': {
          background: '#f7f7fa',
        },
        '.item': {
          border:'none !important',
        }
      },
      '.sectionWrapper': {
        width: "70%",
      },
      '.sectionWrapperInterior': {
        padding: '.5rem 1rem',
        borderRadius: '10px',
        border: '1px solid #333',
        background:'#f7f7fa',
      },
      '.headerWrap': {
        display:'flex',
        justifyContent:'space-between',
      },
      '.downloadButtonWrap': {
        width:'60%',
        display:"flex",
        justifyContent:"flex-end",

      },
      section: {
        '.sections': {},
        '.mainBox': {
          position: 'relative',
          display: 'flex',
          justifyContent: 'space-between',
          marginTop:'1rem',
          width: '100%',
          '.contentBox': {
            width: '100%',
            paddingLeft:'.5rem',
          },

          '.subSections': {
            position:'relative',
            width: '100%',
            _last: { borderBottom: 'none' },
          },
          '.subSectionsInterior': {
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
          },
          '.subSection': {
            display: 'flex',
          },
          '.subSectionPE': {
            display:'block',
          },
          '.alignRight': {
            textAlign: 'right',
          },
          /**Education**/

          '.educationItemWrap': {
            display:'flex',
            justifyContent:'space-between',
          },
          '.educationItem': {
            display:'flex',
            justifyContent:'flex-start',
          },
          '.educationItemText': {
            margin:'0 .4rem',
          },
          /**Expertise**/
          '.expertise': {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            maxWidth: '70%',
            margin: '0 auto',
          },
          '.skill': {
            display: 'inline',
            paddingRight: '.4rem',
            paddingTop: '.4rem',
            paddingBottom: '.4rem',
            textWrap: 'nowrap',
            _after: {
              paddingLeft:'.4rem',
              content:'"|"'
            },
            //nested pseudo classes!! Who knew?
            _last: { _after: {content: '""'} },
          },
          /**Professional Experience**/
          '.editableWork': {
            padding: 0,
            margin: 0,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            fontWeight: 'normal',
            width:'99%',
            display:'flex',

          },
          '.bulletsWrap': {
            display: 'flex',
            width: '100%',
            flexWrap: 'nowrap',
            marginLeft: '-15px',
          },
          '.bulletIcon': {
            paddingTop: '.8rem',
            paddingLeft: '1rem',
            marginRight: '.5rem',
            fontSize: '.4rem',
          },
          '.jobTitleWrapper': {
            marginTop: '.2rem',
          },
          '.jobTitle': {
            fontWeight: 'bold',
            fontSize: '20px',
          },
          '.startDate': {
            textAlign: 'right',
            display: 'inline',
          },
          '.endDate': {
            marginLeft: '.4rem',
            display: 'inline',
          },
          '.dates': {
            marginTop: '.4rem',
            fontStyle: 'italic',
            textAlign: 'right',
marginRight: '.5rem',
          },
          '.address': {
            marginTop: '.4rem',
            fontStyle: 'italic',
            textAlign: 'right',
            marginRight: '.5rem',
          },
          /**Computer Skills**/

          '.computerSkills': {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            width: '100%',
            paddingTop: '.5rem',
          },
          '.techSkills': {
            marginRight: '.4rem',
          },
          '.csContentBox': {
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
          },
          '.comma': {
            display: 'inline',
            marginRight: '.3rem',
            _last: { display: 'none' },
          },
          /**END Computer Skills**/
          /**Contact**/
          '.infoWrapper': {
            position: 'relative',
            marginLeft: '1rem',
            '.linkWrapper': {
              display: 'flex',
              flexWrap: 'nowrap',
              marginTop: '.3rem',
            },

            '.linkText': {
              fontWeight: 'bold',
              display: 'inline',
              padding: '.2rem',
              marginRight: '.5rem',
              color: 'white',
              backgroundColor: '#ff914D',
              borderRadius: '50%',
              '.link': {
                color: 'red',
              },
            },
          },
          '.contactEditButtonWrap': {
            margin:'.5rem 0 0 .5rem',
            textAlign:'right',
          },
          /** END Contact**/
        },

        '.contact': {
          display: 'flex',
          justifyContent: 'space-between',
          '.header': {
            '.names': {
              'fontSize': '2.8rem',
              'textTransform': 'uppercase',
            },
          },
        },
      },
      '.desktopImg': {
        width:'90%',
        margin:'0 auto',
      },
      accordion: {
        '.name': {
          fontWeight: 'bold',
          fontSize: '22px',
          textTransform: 'uppercase',
        },
        '.sectionTitle': {
          padding: '.2rem 0 .2rem .5rem',
          backgroundColor: '#D7DDE8',
          color: '#000',
          textTransform: 'uppercase',
          fontSize: '20px',
          marginTop: '5px',
          marginBottom: '8px',
          textAlign: 'left',
        },
        '.divider': {
          display: 'inline',
          margin: '0 .4rem',
        },
        'h2': {
          width: '100%',
        },
        '.item': {
          width: '100%',
          border: 'none !important',
        },
        '.panel': {
          paddingBotton: '4px',
          //  width: '100%',
        },
        '.accordionButton': {
          width: '100%',
          padding: '0',
          justifyContent: 'space-between',
          color: '#000',
          backgroundColor: '#D7DDE8',
          marginBottom:'.5rem',
        },
        '.accordionPanel': {
          position: 'relative',
          display: 'flex',
          justifyContent: 'flex-end',
          padding:'0',
        },
        '.previewWrapper': {
          width: '100%',
        },
        '.icon': {
          border: 'none !important',
          marginRight: '1rem',
          fontWeight: 'bold',
          width: '2rem !important',
          height: '2rem !important',
          color: '#000',
          paddingRight: '.5rem',

        },
        '.heading': {
          width: '100%',

        },
        '.editButtonDiv': {
          position: "relative",
          display: 'flex',
          justifyContent: 'flex-end',

          '.editButton': {
            width:'fit-content !important',
            padding: '.3rem 2rem  !important',
            backgroundColor: '#FF914D !important',
            right: '0',
            margin: '.5rem 0 1.5rem 0',
          },
        },

      },
      whiteBox: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '.5rem 0 2rem 0',
        marginBottom: '1rem',
        '.divider': {
          padding: '.5rem 0',
          borderBottom: '1px solid #333',
          width: '100%',
          _last: { borderBottom: 'none' },
        },
        '.date': {
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        },


      },
      work: {
        display: 'flex',
        justifyContent: 'space-between',
        w: '100%',
        p: '10px',
      },
      sidebar: {
        '.sidebarButton': {
          backgroundColor: '#CC1F88 !important',

          _hover: {
            //background: '#D7DDE8 !important',
          },
        },
        '.panelInterior': {
          padding: '0 0 1rem 0 !important',
          backgroundColor: '#f7f7fa',
          border: '1px solid transparent',
          borderRadius: '10px !important',
        },
        '.panelPadding': {
          padding: '0 1.2rem',
        },
        '.sidebarSectionTitle': {
          color: '#fff !important',
          background: '#CC1F88 !important',
          fontSize: '25px',
        },
        '.emptySection': {
          color: '#333',
          borderBottom: '1px solid white',
          padding: '.5rem 0',
          _last: { borderBottom: 'none' },
        },
        'a': {
          textDecoration: 'underline',
        },
        '.sidebarIcon': {
          color: '#fff !important',
        },
        '.template': {
          textAlign: 'center',
          padding: '.5rem 1rem .5rem 1rem',
        },
        '.borderBox': {
          borderRadius: '10px',
        },

        '.content': {
          margin: '1rem 0',
        },
        '.contentText': {
          fontWeight: 'bold',
          fontSize: '22px',
          textAlign: 'center',
        },
        '.sideEditButton': {
          background: '#CC1F88 !important',
          fontSize: '[16px 12px',
          borderRadius: '4px',

          height: '32px',
          width: '90px',
          color: 'white',
          padding: '.2rem 1rem !important',
        },
      },
    },
  },
};

